import { StateDefinition, StateId } from '../types';

export const STATES: StateDefinition[] = [
  { id: 'FOCUSED',        short: 'F',  color: '#22c55e', label: '집중' },
  { id: 'THINKING_UP',    short: 'TU', color: '#06b6d4', label: '생각(위)' },
  { id: 'LOOKING_SIDE',   short: 'LS', color: '#ef4444', label: '옆 봄' },
  { id: 'LOOKING_DOWN',   short: 'LD', color: '#eab308', label: '아래 봄' },
  { id: 'GAZING_OUT',     short: 'GO', color: '#6b7280', label: '먼 곳' },
  { id: 'LISTENING',      short: 'LI', color: '#a855f7', label: '음성 감지' },
  { id: 'RETURNED',       short: 'R',  color: '#f59e0b', label: '복귀' },
  { id: 'BURST_TYPING',   short: 'BT', color: '#ef4444', label: '빠른 입력' },
  { id: 'SLOW_TYPING',    short: 'ST', color: '#06b6d4', label: '느린 입력' },
  { id: 'WRITING_NORMAL', short: 'WN', color: '#22c55e', label: '정상 작성' },
  { id: 'IDLE',           short: 'ID', color: '#6b7280', label: '대기' },
];

export const NON_FOCUS_STATES = new Set<StateId>([
  'LOOKING_SIDE',
  'LOOKING_DOWN',
  'GAZING_OUT',
  'LISTENING',
]);
